/* flow */

import * as React from 'react';

import styles from '../scss/components/header.scss';
import data from '../data/data.js';
import { replaceState, setPageTitle } from './helpers';
import { root1002019Logo } from './images';

/*
 * This is the Header component that has links to
 * Kinja-y stuff
 */
export default class Header extends React.Component {

	constructor(props) {
		super(props);
		this.mobileRef = null;
	}

	componentDidUpdate(prevProps) {
		if (this.props.isVisible && !prevProps.isVisible) {
			this.onHeaderVisible();
		}
	}

	onHeaderVisible = () => {
		const path = this.props.filter ? `/${this.props.filter.toLowerCase()}/` : '/';
		replaceState(path);
		setPageTitle(this.props.filter);
	}

	renderPersonDesktop = () => {
		const sorted = data.items.sort((a, b) => {
			return a.fields.rank - b.fields.rank;
		});

		return (
			sorted.map(person => {
				const { name, imageUrl } = person.fields;
				const { card } = styles;
				const { id } = person.sys;
				return (
						<div
							key={id}
							className={card}
							onClick={() => this.props.resetAndScrollIntoView(id, name)}
						>
							<img src={imageUrl.replace(/\/upload/, '/upload/c_fill,f_auto,fl_progressive,h_200,q_60,w_200')} alt={name} />
							<p>{name}</p>
						</div>
				);
			})
		);
	}

	renderPersonMobile = (start, end) => {
		const sorted = data.items.sort((a, b) => {
			return a.fields.rank - b.fields.rank;
		});

		return (
			sorted.map((person, index) => {
				const { name, imageUrl } = person.fields;
				const { card } = styles;
				const { id } = person.sys;

				if (index + 1 > start && index < end) {
					return (
						<div key={id}>
							<a
								className={card}
								onClick={() => this.props.resetAndScrollIntoView(id, name)}
							>
								<img src={imageUrl.replace(/\/upload/, '/upload/c_fill,f_auto,fl_progressive,h_200,q_60,w_200')} alt={name} />
								<p>{name}</p>
							</a>
						</div>
					);
				}
			})
		);
	}

	componentDidMount() {
		if (this.mobileRef) {
			this.mobileRef.addEventListener('touchstart', ()=>{}, true);
		}
	}

	render() {
		const { container, containerMobile, desktopContainer, grid, leftSpace, logo, mobileContainer, row } = styles;
		return (
			<div id='top'>
				<div className={desktopContainer}>
					<div className={container}>
						<div className={logo} style={{backgroundImage: `url(${root1002019Logo})`}}></div>
						{this.renderPersonDesktop()}
					</div>
				</div>
				<div className={mobileContainer}>
					<div className={containerMobile}>
						<div className={logo} style={{backgroundImage: `url(${root1002019Logo})`}}></div>
						<div className={grid} ref={element => { this.mobileRef = element; }}>
							<div className={row} >
								{this.renderPersonMobile(0, 33)}
							</div>
							<div className={[row, leftSpace].join(' ')} >
								{this.renderPersonMobile(34, 66)}
							</div>
							<div className={row} >
								{this.renderPersonMobile(67, 101)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/components/header.js